import React from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@nextui-org/react';
import { User } from 'common/src/utils/types';
import { deleteUser } from 'common/src/api/users';
import { toast } from 'react-toastify';
import useGeneralStore from '../../../store/useGeneralStore';

interface ModalDeleteUserProps {
  isOpen: boolean;
  onClose: () => void;

  user: User;
}

const ModalDeleteUser: React.FC<ModalDeleteUserProps> = ({
  isOpen,
  onClose,

  user,
}) => {
  const { fetchUsers } = useGeneralStore();
  const onDelete = async () => {
    const res = await deleteUser(user.auth_id);
    if (res) {
      onClose();
      fetchUsers();
      toast.success('Usuario eliminado correctamente');
    } else {
      toast.error('Error al eliminar el usuario');
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        <ModalHeader>Delete User</ModalHeader>
        <ModalBody>
          Are you sure you want to delete the user {user.first_name}{' '}
          {user.last_name}?
        </ModalBody>
        <ModalFooter>
          <Button color='default' variant='light' onPress={onClose}>
            Cancel
          </Button>
          <Button color='danger' onPress={onDelete}>
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalDeleteUser;
